module.exports = __webpack_public_path__ + "img/relvado_02.6c140d58.jpg";